// extracted by mini-css-extract-plugin
export default {"notification":"styles_notification__aYX5h"};